import { getLocale, replaceInterpolation } from "@jti/fe-common";
import { formatWithIntl } from "@jti/format-price";
import { useSelector } from "@jti/store";
import { useAemModel } from "../../contexts/AemModelContext";
import { useFreeTrial } from "../../hooks/useFreeTrial";
export const useDiscountDisclaimer = () => {
    const { discountDisclaimer } = useAemModel();
    const { isFreeTrial } = useFreeTrial();
    const minimumPayableAmountStandardCart = useSelector((state) => state.cart.minimumPayableAmount);
    const minimumPayableAmountFreeTrialCart = useSelector((state) => state.freeTrialCart.minimumPayableAmount);
    const minimumPayableAmount = isFreeTrial ? minimumPayableAmountFreeTrialCart : minimumPayableAmountStandardCart;
    const isMinimumPayableAmountEnabled = Boolean(minimumPayableAmount?.value && minimumPayableAmount?.value !== 0);
    const locale = getLocale();
    const formattedValue = minimumPayableAmount
        ? `<span style="direction: ltr;">${formatWithIntl({ ...minimumPayableAmount, locale })}</span>`
        : "";
    const warningMessage = isMinimumPayableAmountEnabled && discountDisclaimer?.warningMessage
        ? replaceInterpolation(discountDisclaimer?.warningMessage, [formattedValue])
        : null;
    const disclaimerMessage = (isMinimumPayableAmountEnabled || discountDisclaimer?.enabledWhenZeroValueDeposit) && discountDisclaimer?.enabled
        ? discountDisclaimer?.disclaimerMessage
        : null;
    return {
        warningMessage,
        disclaimerMessage,
    };
};
//# sourceMappingURL=useDiscountDisclaimer.js.map